


import { Component, Vue } from 'vue-property-decorator';
import Btn, { BtnColor, BtnWidth } from '@/shared/components/btn.component.vue';
import ExpansionPanel from '@/shared/components/expansion.panel.component.vue';

@Component({
  components: {
    Btn,
    ExpansionPanel,
  },
})
export default class PartialBtn extends Vue {
  private btnWidth = BtnWidth;
  private btnColor = BtnColor;

  private clickButton() {
    alert('FUNCIONA!!');
  }
}
